import { createContext } from 'react';
import { TableTypes } from './TableTypes';

const tableContext = createContext({} as TableTypes);

export default tableContext;
